import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Carousel, Container } from "react-bootstrap";
import axios from "axios";
import { API_URI } from "../Common/data";

function Offers() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${API_URI}/banners/all`); 
        if(response.status === 200){
            setBanners(response?.data?.data ||[]); 
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching banners:", error);
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  return (
    <>
      <Navbar />
      <Container>
        <div className="news-banner-offer news-banner2-offer">
          <p>Offers</p>
          <br />
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <Carousel>
            {banners.map((banner, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={banner.imageUrl} // Assuming API gives 'image' field
                  alt={`Slide ${index + 1}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => window.open(banner.link, "_blank")} // Open in new tab
                />
              </Carousel.Item>
            ))}
          </Carousel>
        )}
      </Container>
      <Footer />
    </>
  );
}

export default Offers;
